import {DomainUri} from '../../state/types/domain-registry.js';
import {Reason, reason} from '../../reason.js';

export function contextNotAuthorized(domainUri: DomainUri) {
    return `${domainUri}.errors.not_authorized`;
}
export function contextBadLifetime(domainUri: DomainUri) {
    return `${domainUri}.errors.bad_lifetime`;
}

export function contextDestroyedExplicitly(domainUri: DomainUri): Reason {
    return reason(`${domainUri}.destroyed`, 'Context destroyed explicitly');
}


export function contextDestroyedPeerLeft(domainUri: DomainUri): Reason {
    return reason(`${domainUri}.peer-left`, 'Context destroyed because its owner/last peer left');
}

export function failure(domainUri: DomainUri) {
    return `${domainUri}.errors.failure`;
}
